/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration layer (BOL) Notifications API
 * Business Orchestration layer (BOL) Notifications API.  This API is used to manage subscriptions and consumers for BOL notifications. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SubscriptionStatus } from './SubscriptionStatus';
import {
    SubscriptionStatusFromJSON,
    SubscriptionStatusFromJSONTyped,
    SubscriptionStatusToJSON,
    SubscriptionStatusToJSONTyped,
} from './SubscriptionStatus';
import type { SubscriptionQuotas } from './SubscriptionQuotas';
import {
    SubscriptionQuotasFromJSON,
    SubscriptionQuotasFromJSONTyped,
    SubscriptionQuotasToJSON,
    SubscriptionQuotasToJSONTyped,
} from './SubscriptionQuotas';
import type { ResumeStrategy } from './ResumeStrategy';
import {
    ResumeStrategyFromJSON,
    ResumeStrategyFromJSONTyped,
    ResumeStrategyToJSON,
    ResumeStrategyToJSONTyped,
} from './ResumeStrategy';

/**
 * Request body for patching an existing subscription.
 * 
 * ## Enabling/Disabling
 * 
 * To disable a subscription, set `status` to `DISABLED`.
 * To enable a subscription, set `status` to `ACTIVE` and optionally provide `resumeStrategy` and `resumeTimestamp`.
 * 
 * ## Resume Strategies
 * 
 * - **CONTINUE** (default): Resume from last committed offset
 * - **LATEST**: Resume from current offset (skip pending messages)
 * - **EARLIEST**: Resume from beginning of retention period
 * - **FROM_TIMESTAMP**: Resume from specified timestamp (requires `resumeTimestamp`)
 * 
 * @export
 * @interface SubscriptionPatchRequest
 */
export interface SubscriptionPatchRequest {
    /**
     * Display name of the subscription.
     * @type {string}
     * @memberof SubscriptionPatchRequest
     */
    name?: string;
    /**
     * 
     * @type {SubscriptionStatus}
     * @memberof SubscriptionPatchRequest
     */
    status?: SubscriptionStatus;
    /**
     * 
     * @type {ResumeStrategy}
     * @memberof SubscriptionPatchRequest
     */
    resumeStrategy?: ResumeStrategy;
    /**
     * Timestamp from which to resume consumption. Required when resumeStrategy is FROM_TIMESTAMP and status is set to ACTIVE.
     * @type {Date}
     * @memberof SubscriptionPatchRequest
     */
    resumeTimestamp?: Date;
    /**
     * 
     * @type {SubscriptionQuotas}
     * @memberof SubscriptionPatchRequest
     */
    quotas?: SubscriptionQuotas;
}



/**
 * Check if a given object implements the SubscriptionPatchRequest interface.
 */
export function instanceOfSubscriptionPatchRequest(value: object): value is SubscriptionPatchRequest {
    return true;
}

export function SubscriptionPatchRequestFromJSON(json: any): SubscriptionPatchRequest {
    return SubscriptionPatchRequestFromJSONTyped(json, false);
}

export function SubscriptionPatchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionPatchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'status': json['status'] == null ? undefined : SubscriptionStatusFromJSON(json['status']),
        'resumeStrategy': json['resumeStrategy'] == null ? undefined : ResumeStrategyFromJSON(json['resumeStrategy']),
        'resumeTimestamp': json['resumeTimestamp'] == null ? undefined : (new Date(json['resumeTimestamp'])),
        'quotas': json['quotas'] == null ? undefined : SubscriptionQuotasFromJSON(json['quotas']),
    };
}

export function SubscriptionPatchRequestToJSON(json: any): SubscriptionPatchRequest {
    return SubscriptionPatchRequestToJSONTyped(json, false);
}

export function SubscriptionPatchRequestToJSONTyped(value?: SubscriptionPatchRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'status': SubscriptionStatusToJSON(value['status']),
        'resumeStrategy': ResumeStrategyToJSON(value['resumeStrategy']),
        'resumeTimestamp': value['resumeTimestamp'] == null ? value['resumeTimestamp'] : value['resumeTimestamp'].toISOString(),
        'quotas': SubscriptionQuotasToJSON(value['quotas']),
    };
}

